export function UnixToDate(value) {
    if (!value) return '';
    
    try {
        // تبدیل یونیکس تایم به میلی‌ثانیه
        const timestamp = value * 1000;
        
        // اختلاف زمانی تهران با UTC به میلی‌ثانیه (3 ساعت و 30 دقیقه)
        // منطقه زمانی تهران +3:30 است
        const tehranOffsetMs = (3 * 60 + 30) * 60 * 1000;
        
        // محاسبه زمان در منطقه زمانی تهران با اضافه کردن اختلاف زمانی
        const tehranTimestamp = timestamp + tehranOffsetMs;
        
        // تاریخ و زمان با فرمت ISO در UTC
        // اینجا مستقیماً محاسبه می‌کنیم و نیازی به تبدیل منطقه زمانی نیست
        
        // محاسبه روزها، ساعت‌ها، دقیقه‌ها و ثانیه‌ها از زمان یونیکس
        const milliseconds = tehranTimestamp % 1000;
        const totalSeconds = Math.floor(tehranTimestamp / 1000);
        const seconds = totalSeconds % 60;
        const totalMinutes = Math.floor(totalSeconds / 60);
        const minutes = totalMinutes % 60;
        const totalHours = Math.floor(totalMinutes / 60);
        const hours = totalHours % 24;
        const totalDays = Math.floor(totalHours / 24);
        
        // محاسبه تاریخ از تعداد روزها از 1970-01-01
        let year = 1970;
        let month = 1;
        let day = 1;
        let daysLeft = totalDays;
        
        // تعداد روز‌های هر ماه
        const daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        
        // محاسبه سال
        while (true) {
            const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
            const daysInYear = isLeapYear ? 366 : 365;
            
            if (daysLeft >= daysInYear) {
                daysLeft -= daysInYear;
                year++;
            } else {
                break;
            }
        }
        
        // محاسبه ماه و روز
        for (let m = 1; m <= 12; m++) {
            // بررسی ماه فوریه در سال کبیسه
            let daysInCurrentMonth = daysInMonth[m];
            if (m === 2 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)) {
                daysInCurrentMonth = 29;
            }
            
            if (daysLeft < daysInCurrentMonth) {
                month = m;
                day = daysLeft + 1; // +1 چون از روز صفر شروع نمی‌کنیم
                break;
            }
            
            daysLeft -= daysInCurrentMonth;
        }
        
        // تبدیل به فرمت ISO با 'Z' در انتها
        // پد کردن اعداد یک رقمی با صفر در ابتدا
        const pad = (num) => num.toString().padStart(2, '0');
        // بازگرداندن تاریخ ISO بدون تغییر منطقه زمانی
        // دقت کنید که ما با UTC+0 کار می‌کنیم، بنابراین 'Z' در انتها صحیح است
        return `${year}-${pad(month)}-${pad(day)}T${pad(hours)}:${pad(minutes)}:${pad(seconds)}.${milliseconds.toString().padStart(3, '0')}Z`;
    } catch (error) {
        console.error('خطا در تبدیل یونیکس تایم به تاریخ:', error);
        return '';
    }
}
